import React, { useEffect, useState } from "react";
import { Row, Col } from "reactstrap";
import { Typography } from "@material-ui/core";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import PrintIcon from "@material-ui/icons/Print";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import { getInspection, byVehicleIdInspectionId } from "../../graphql/queries";
import gql from "graphql-tag";
import { connect } from "react-redux";
import { spinnerService } from "@chevtek/react-spinners";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import checked from "../../assets/img/checked.PNG";
import unchecked from "../../assets/img/unchecked.PNG";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Grid from "@material-ui/core/Grid";
import spacing from "@material-ui/core/styles/spacing";
import { Storage } from "aws-amplify";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    padding: "50px"
  },
  paper: {
    padding: theme.spacing.unit * 1,
    textAlign: "center",
    color: theme.palette.text.secondary,
    marginLeft: "8px",
    border: "solid"
  }
});
const DialogTitle = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey[500]
  }
}))(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    borderTop: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit
  }
}))(MuiDialogActions);

const InspectionCheckData = [
  {
    check: false,
    ObsID: 0,
    Obs: "Chock Wheels",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: false,
    truckAB: false,
    busHB: true,
    truckHB: true,
    tractor: false
  },
  {
    check: false,
    ObsID: 1,
    Obs: "Oil, Coolant, Auto Transmission Levels",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 2,
    Obs: "Hydraulic Brake Fluid Level",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: false,
    truckAB: false,
    busHB: true,
    truckHB: true,
    tractor: false
  },
  {
    check: false,
    ObsID: 3,
    Obs: "P/W Steering, Steer Hub Oil Level",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 4,
    Obs: "Belts, Fan, Pulleys, Tensioners",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 5,
    Obs: "Air Filter, Air Filter Tubes and Pipes",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 6,
    Obs: "Air Compressor Intake/Discharge Hoses/Lines",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 7,
    Obs: "Air Compressor Signs of Heat and/or Oil",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 8,
    Obs: "Dryer/Governor Condition, Exhaust Port",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 9,
    Obs: "Steering Box Mounts, Leaks, Secured",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 10,
    Obs: "Steering Wheel Lash And Mounts",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 11,
    Obs: "Park Brake Operation, Clutch Free Play",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 12,
    Obs: "Oil, Coolant, Charging, Air Gauges",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 13,
    Obs: "Windshield, Wipers, Mirrors Operation",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 14,
    Obs: "Horn, Defroster, Warning Devices",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 15,
    Obs: "Triangle Box and Fire Extinguisher",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 16,
    Obs: "Hydraulic Brake Operation & Condition",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: true,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: false,
    truckAB: false,
    busHB: true,
    truckHB: true,
    tractor: false
  },
  {
    check: false,
    ObsID: 17,
    Obs: "Electric Brake Operation & Condition",
    busAOH: false,
    truckAOH: false,
    trailerAB: false,
    trailerHB: false,
    trailerEB: true,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: false,
    truckAB: false,
    busHB: false,
    truckHB: false,
    tractor: false
  },
  {
    check: false,
    ObsID: 18,
    Obs: "Electric Brake Break-A-Way Operation",
    busAOH: false,
    truckAOH: false,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: false,
    truckAB: false,
    busHB: false,
    truckHB: false,
    tractor: false
  },
  {
    check: false,
    ObsID: 19,
    Obs: "All lights and Reflectors",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 20,
    Obs: "Trailer Plug, Receptacle, Cord, 7-Way",
    busAOH: false,
    truckAOH: false,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: false,
    truckAB: false,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 21,
    Obs: "Box/Bed Mounts, Roof/Skin, Mud Flaps",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 22,
    Obs: "Tires - Depths within Spec and Condition",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 23,
    Obs: "Rims, Lugs and Dual Mating",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 24,
    Obs: "Radiator Condition, Hoses, Leaks",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 25,
    Obs: "Engine and Transmission Mounts",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 26,
    Obs: "King Pins, Steering Arm(s), Tie Rods",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 27,
    Obs: "Exhaust System, Driveline, Carriers",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 28,
    Obs: "U-Bolts, Shocks, Leafs, Springs",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 29,
    Obs: "Hangers, Torque Arms & Equalizers",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 30,
    Obs: "Frame - Bolts, Welds, Cross Members",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 31,
    Obs: "Hub Oil Levels, Wheel Seals",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 32,
    Obs: "Fuel Tank Mounts, Caps, Hoses",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 33,
    Obs: "General Engine And Drive Train Leaks",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 34,
    Obs: "Wire & Hoses - Rubbing or Chaffing",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 35,
    Obs: "Lift Gate Operation, Condition",
    busAOH: false,
    truckAOH: false,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: false,
    truckAB: false,
    busHB: false,
    truckHB: false,
    tractor: false
  },
  {
    check: false,
    ObsID: 36,
    Obs: "Battery(s) Condition, Connections",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 37,
    Obs: "ABS Warning Light",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: false,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 38,
    Obs: "Low Air Audible And/Or Visual Alarm",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 39,
    Obs: "Air Compressor Build Up Team",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 40,
    Obs: "Air Dryer/Governor Purge Cycle",
    busAOH: true,
    truckAOH: true,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 41,
    Obs: "Air Loss-Supply Leakage - Unapplied",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 42,
    Obs: "Air Loss-Supply Leakage - Applied",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 43,
    Obs: "Tractor Protection System",
    busAOH: false,
    truckAOH: false,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: false,
    truckAB: false,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 44,
    Obs: "Air Tank(s) Mounts And Drained",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 45,
    Obs: "Air Brake Lines/Hoses Secured",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 46,
    Obs: "Air Brake Chambers Condition, Mounts",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 47,
    Obs: "Air Slack(s) Balance, 90 Angle",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 48,
    Obs: "Air Slack Adjuster(s) Stroke within Spec",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: true,
    truckAB: true,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 49,
    Obs: "Drums And Rotors Condition",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 50,
    Obs: "Brake Lining(Shoes/Pads) Condition",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 51,
    Obs: "Overall Brake Adjustment",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 52,
    Obs: "Fifth Wheel, Pintle Hooks & Hitches",
    busAOH: false,
    truckAOH: false,
    trailerAB: false,
    trailerHB: false,
    trailerEB: false,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busAB: false,
    truckAB: false,
    busHB: false,
    truckHB: false,
    tractor: true
  },
  {
    check: false,
    ObsID: 53,
    Obs: "Fifth Wheel Pin",
    busAOH: false,
    truckAOH: false,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: false,
    van: false,
    pickup: false,
    limo: false,
    busHB: false,
    truckHB: false,
    tractor: false
  },
  {
    check: false,
    ObsID: 54,
    Obs: "Set Parking Brake",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  },
  {
    check: false,
    ObsID: 55,
    Obs: "Remove Wheel Chocks(Optional)",
    busAOH: true,
    truckAOH: true,
    trailerAB: true,
    trailerHB: true,
    trailerEB: true,
    rv: true,
    van: true,
    pickup: true,
    limo: true,
    busAB: true,
    truckAB: true,
    busHB: true,
    truckHB: true,
    tractor: true
  }
];
const InspectionReportView = props => {
  const [inspectionDetails, setInspectionDetails] = useState({});
  const [vehicleType, setVehicleType] = useState("");
  const [defectsRepaired, setDefectsRepaired] = useState([]);
  const [defectsActive, setDefectsActive] = useState([]);
  const [imgLink, setImgLink] = useState("");
  const [popup, setPopup] = useState(false);

  const { classes } = props;

  const printDocument = () => {
    spinnerService.show("mySpinner");
    const input = document.getElementById("pdfdiv");
    html2canvas(input).then(canvas => {
      var imgWidth = 200;
      var pageHeight = 290;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      var position = 0;
      var heightLeft = imgHeight;
      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
      spinnerService.hide("mySpinner");
      pdf.autoPrint();
      window.open(pdf.output("bloburl"), "_blank");
    });
  };
  const pdfDocument = () => {
    spinnerService.show("mySpinner");
    const input = document.getElementById("pdfdiv");
    html2canvas(input).then(canvas => {
      var imgWidth = 200;
      var pageHeight = 290;
      var imgHeight = (canvas.height * imgWidth) / canvas.width;
      var heightLeft = imgHeight;
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      var position = 0;
      var heightLeft = imgHeight;
      pdf.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
      spinnerService.hide("mySpinner");
      pdf.save("InspectionForm.pdf");
    });
  };
  const getSomeData = async id => {
    spinnerService.show("mySpinner");
    const inspectionData = await props.client.query({
      query: gql(getInspection),
      fetchPolicy: `network-only`,
      variables: { id }
    });
    
    const inspectionDataDefects = await props.client.query({
      query: gql(byVehicleIdInspectionId),
      fetchPolicy: `network-only`,
      variables: { vehicleId: inspectionData.data.getInspection.vehicle.id }
    });
    const defData = inspectionDataDefects.data.byVehicleIdInspectionId.items.filter(
      dt => dt.sourceId === id
    );
    
    const vehicle = inspectionData.data.getInspection.vehicle;
    const inspData = inspectionData.data.getInspection;
    setVehicleType(
      inspectionData.data.getInspection.vehicle.vehicleType.vehicleType
    );
    let inspForm =
      inspData.inspectionForm
        ? await Storage.get(inspData.inspectionForm.key)
        : null;
    
    
    let dispObj = {
      vehicleId: vehicle.customerVehicleId,
      carrier: vehicle.customer.id,
      date: new Date(inspData.endAt).toISOString().split("T")[0],
      mileage: vehicle.currentMileage,
      observations: inspData.inspectionObservations,
      inspType: inspData.inspectionType,
      customerType: vehicle.customer.registeredInspectionType,
      sticker: inspData.federalStickerUpdated,
      nextdue: inspData.nextInspectionDue,
      inspReport:
        inspData.inspectionReport && inspData.inspectionReport.length > 0
          ? await Storage.get(inspData.inspectionReport[0].key)
          : null,
      inspForm:
        inspData.inspectionForm
          ? await Storage.get(inspData.inspectionForm.key)
          : null
    };
    let activeDefs = defData.filter(
      ad => !["REPAIRED", "REVOKED"].includes(ad.status)
    );
    let archiveDefs = defData.filter(ad =>
      ["REPAIRED", "REVOKED"].includes(ad.status)
    );
    
    
    
    setDefectsActive(activeDefs);
    setDefectsRepaired(archiveDefs);
    setInspectionDetails(dispObj);

    spinnerService.hide("mySpinner");
  };
  useEffect(() => {
    getSomeData(props.match.params.iId);
  }, []);
  const checkedOrUnchecked = flag => {
    let img = <img src={checked} alt="checked" height="15px" width="15px" />;
    if (flag === false) {
      img = <img src={unchecked} alt="unchecked" height="15px" width="15px" />;
    }
    return img;
  };
  const RenderListItemObs = ({ items }) => {
    let obsArray = items;
    let val;
    if (vehicleType === "Tractor (Air Brakes)") {
      obsArray = obsArray.filter(a => a.tractor !== false);
      val = obsArray.length / 3;
    } else if (
      ["Pick-up Truck", "Van", "Limousine", "RV-Bus Non-Passenger"].includes(
        vehicleType
      )
    ) {
      obsArray = obsArray.filter(a => a.limo !== false);
      val = obsArray.length / 3;
    } else if (
      ["Bus (Air Brakes)", "Straight Truck (Air Brakes)"].includes(vehicleType)
    ) {
      obsArray = obsArray.filter(a => a.busAB !== false);
      val = obsArray.length / 3;
    } else if (
      ["Bus (Hydraulic Brakes)", "Straight Truck (Hydraulic Brakes)"].includes(
        vehicleType
      )
    ) {
      obsArray = obsArray.filter(a => a.busHB !== false);
      val = obsArray.length / 3;
    } else if (
      [
        "Bus (Air over Hydraulic Brakes)",
        "Straight Truck (Air over Hydraulic Brakes)"
      ].includes(vehicleType)
    ) {
      obsArray = obsArray.filter(a => a.busAOH !== false);
      val = obsArray.length / 3;
    } else if (vehicleType === "Trailer (Air Brakes)") {
      obsArray = obsArray.filter(a => a.trailerAB !== false);
      val = obsArray.length / 3;
    } else if (vehicleType === "Trailer (Hydraulic Brakes)") {
      obsArray = obsArray.filter(a => a.trailerHB !== false);
      val = obsArray.length / 3;
    } else if (vehicleType === "Trailer (Electric Brakes)") {
      obsArray = obsArray.filter(a => a.trailerEB !== false);
      val = obsArray.length / 3;
    }
    val = obsArray.length / 3;
    return (
      <div style={{ width: "99%", margin: "auto" }}>
        <Grid
          container
          style={{ flexGrow: 1, marginTop: "8px" }}
          justify="center"
          spacing={2}
        >
          <Grid key={1} item xs={4}>
            <Paper className={classes.paper}>
              <List dense>
                {obsArray.slice(0, val).map(item => {
                  return (
                    <ListItem style={{ padding: "2px" }} key={item}>
                      <ListItemText style={{ fontSize: "12px" }} id={item.Obs}>
                        {item.Obs}
                      </ListItemText>
                      <ListItemSecondaryAction>
                        {inspectionDetails.observations !== undefined &&
                          (inspectionDetails.observations.includes(item.Obs)
                            ? checkedOrUnchecked(true)
                            : checkedOrUnchecked(false))}
                      </ListItemSecondaryAction>
                    </ListItem>
                  );
                })}
              </List>
            </Paper>
          </Grid>
          <Grid key={2} item xs={4}>
            <Paper className={classes.paper}>
              <List dense>
                {obsArray.slice(val, 2 * val).map(item => {
                  return (
                    <ListItem style={{ padding: "2px" }} key={item}>
                      <ListItemText style={{ fontSize: "12px" }} id={item.Obs}>
                        {item.Obs}
                      </ListItemText>
                      <ListItemSecondaryAction>
                        {inspectionDetails.observations !== undefined &&
                          (inspectionDetails.observations.includes(item.Obs)
                            ? checkedOrUnchecked(true)
                            : checkedOrUnchecked(false))}
                      </ListItemSecondaryAction>
                    </ListItem>
                  );
                })}
              </List>
            </Paper>
          </Grid>
          <Grid key={3} item xs={4}>
            <Paper className={classes.paper}>
              <List dense>
                {obsArray.slice(2 * val, 3 * val).map(item => {
                  return (
                    <ListItem style={{ padding: "2px" }} key={item}>
                      <ListItemText style={{ fontSize: "12px" }} id={item.Obs}>
                        {item.Obs}
                      </ListItemText>
                      <ListItemSecondaryAction>
                        {inspectionDetails.observations !== undefined &&
                          (inspectionDetails.observations.includes(item.Obs)
                            ? checkedOrUnchecked(true)
                            : checkedOrUnchecked(false))}
                      </ListItemSecondaryAction>
                    </ListItem>
                  );
                })}
                {["DOT_ANNUAL_INSPECTION", "DOTANDBIT"].includes(
                  inspectionDetails.inspType
                ) && (
                  <ListItem style={{ padding: "2px" }}>
                    <ListItemText style={{ fontSize: "12px" }}>
                      Federal Annual Sticker Updated ?
                    </ListItemText>
                    <ListItemSecondaryAction>
                      {inspectionDetails.sticker !== null
                        ? checkedOrUnchecked(inspectionDetails.sticker)
                        : checkedOrUnchecked(false)}
                    </ListItemSecondaryAction>
                  </ListItem>
                )}
              </List>
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  };

  const RenderPopUp = () => {
    return (
      <div>
        <Dialog
          onClose={() => setPopup(false)}
          aria-labelledby="customized-dialog-title"
          open={popup}
        >
          <DialogTitle
            id="customized-dialog-title"
            onClose={() => setPopup(false)}
          />
          <DialogContent>
            <img src={imgLink} alt="__" />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => window.open(`${imgLink}`)} color="primary">
              Download
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  };
  return (
    <React.Fragment>
      <RenderPopUp />
      <div
        style={{
          width: "20%",
          alignContent: "right",
          alignItems: "right",
          textAlign: "right",
          marginLeft: "auto",
          marginRight: 0
        }}
      >
        <IconButton
          onClick={printDocument}
          color="primary"
          aria-label="print"
          component="span"
        >
          <PrintIcon />
        </IconButton>{" "}
        <IconButton
          color="primary"
          onClick={pdfDocument}
          aria-label="pdf"
          component="span"
        >
          <PictureAsPdfIcon />
        </IconButton>
      </div>
      <div
        style={{
          padding: "8px"
        }}
        id="pdfdiv"
      >
        <Paper className={classes.root} elevation={1}>
          <div style={{ margin: "20px" }}>
            <Row>
              <Typography variant="title">FEDERAL ANNUAL INSPECTION</Typography>
              <Typography style={{ marginLeft: "5px" }} variant="body1">
                As Required By: Federal Motor Carrier Safety Regulation 49 CFR
                396.17
              </Typography>
            </Row>

            <Row style={{ marginTop: "7px" }}>
              <Typography variant="title">
                BIT 90-DAY Mechanical Inspection
              </Typography>
              <Typography variant="body1" style={{ marginLeft: "5px" }}>
                As Required By: California Title 13 CCR 1215
              </Typography>
            </Row>

            <div
              style={{
                textDecoration: "underline",
                padding: "3px"
              }}
            >
              <Row>
                <Col sm={4}>
                  <Typography variant="body2">
                    {" "}
                    {`Carrier: ${inspectionDetails.carrier}`}
                  </Typography>
                  <Typography variant="body2">
                    {" "}
                    {`Mileage: ${
                      inspectionDetails.mileage !== null
                        ? inspectionDetails.mileage
                        : "Not Observed"
                    }`}
                  </Typography>
                </Col>
                <Col sm={4} />
                <Col sm={4}>
                  <Typography variant="body2">
                    {" "}
                    {`Date: ${inspectionDetails.date}`}
                  </Typography>
                  <Typography variant="body2">
                    {" "}
                    {`Vehicle ID: ${inspectionDetails.vehicleId}`}
                  </Typography>
                  {inspectionDetails.inspReport !== null && (
                    <Typography
                      variant="body1"
                      style={{
                        color: "blue",
                        cursor: "pointer"
                      }}
                      onClick={() => {
                        setPopup(true);
                        setImgLink(inspectionDetails.inspReport);
                      }}
                    >
                      View Report
                    </Typography>
                  )}
                  {inspectionDetails.inspForm !== null && (
                    <Typography
                      variant="body2"
                      style={{
                        color: "blue",
                        cursor: "pointer"
                      }}
                      onClick={() => {
                        setPopup(true);
                        setImgLink(inspectionDetails.inspForm);
                      }}
                    >
                      View Form
                    </Typography>
                  )}
                </Col>
              </Row>
            </div>

            <div
              style={
                {
                  //   padding: "3px"
                }
              }
            >
              <Row>
                <Col sm={4}>
                  <List
                    dense
                    style={{
                      width: "100%",
                      maxWidth: "360",
                      margin: "0px 10px"
                      // backgroundColor: theme.palette.background.paper,
                    }}
                  >
                    <ListItem style={{ padding: "2px" }}>
                      <ListItemText style={{ fontSize: "13px" }}>
                        Federal Annual Inspection
                      </ListItemText>
                      <ListItemSecondaryAction>
                        {["DOT_ANNUAL_INSPECTION", "DOTANDBIT"].includes(
                          inspectionDetails.inspType
                        )
                          ? checkedOrUnchecked(true)
                          : checkedOrUnchecked(false)}
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem style={{ padding: "2px" }}>
                      <ListItemText style={{ fontSize: "13px" }}>
                        90-Day Inspection
                      </ListItemText>
                      <ListItemSecondaryAction>
                        {["BIT_90DAY_INSPECTION", "DOTANDBIT"].includes(
                          inspectionDetails.inspType
                        )
                          ? checkedOrUnchecked(true)
                          : checkedOrUnchecked(false)}
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem style={{ padding: "2px" }}>
                      <ListItemText style={{ fontSize: "13px" }}>
                        Lube, Oil Change, Filter Service
                      </ListItemText>
                      <ListItemSecondaryAction>
                        {checkedOrUnchecked(false)}
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem style={{ padding: "2px" }}>
                      <ListItemText style={{ fontSize: "13px" }}>
                        Change Oil and Oil Filter(s)
                      </ListItemText>
                      <ListItemSecondaryAction>
                        {checkedOrUnchecked(false)}
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem style={{ padding: "2px" }}>
                      <ListItemText style={{ fontSize: "13px" }}>
                        Change Fuel Filter(s)
                      </ListItemText>
                      <ListItemSecondaryAction>
                        {checkedOrUnchecked(false)}
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem style={{ padding: "2px" }}>
                      <ListItemText style={{ fontSize: "13px" }}>
                        Lube Chassis
                      </ListItemText>
                      <ListItemSecondaryAction>
                        {checkedOrUnchecked(false)}
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem style={{ padding: "2px" }}>
                      <ListItemText style={{ fontSize: "13px" }}>
                        Check Transmission Oil Level
                      </ListItemText>
                      <ListItemSecondaryAction>
                        {checkedOrUnchecked(false)}
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem style={{ padding: "2px" }}>
                      <ListItemText style={{ fontSize: "13px" }}>
                        Check Differential(s) Oil Level(s)
                      </ListItemText>
                      <ListItemSecondaryAction>
                        {checkedOrUnchecked(false)}
                      </ListItemSecondaryAction>
                    </ListItem>
                    <ListItem style={{ padding: "2px" }}>
                      <ListItemText style={{ fontSize: "13px" }}>
                        Fill WindSheild Washer Fluid
                      </ListItemText>
                      <ListItemSecondaryAction>
                        {checkedOrUnchecked(false)}
                      </ListItemSecondaryAction>
                    </ListItem>
                  </List>
                </Col>
                <Col sm={8}>
                  <Row>
                    <Col sm={6}>
                      <Typography
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        {" "}
                        Problem
                      </Typography>
                    </Col>
                    <Col sm={6}>
                      <Typography
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        {" "}
                        Parts
                      </Typography>
                    </Col>
                  </Row>
                  {defectsRepaired.length > 0 ? (
                    defectsRepaired.map(dd => (
                      <Row style={{ padding: "2px" }} key={dd.id}>
                        <Col sm={6}>
                          <Typography variant="body2">
                            {" "}
                            {`Type: ${dd.defectType}`}
                          </Typography>
                          <Typography variant="body1">
                            {" "}
                            {`Description: ${dd.defectDesc}`}
                          </Typography>
                          <Typography variant="body1">
                            {" "}
                            {`Repair Story: ${
                              dd.repairNotes !== null
                                ? dd.repairNotes
                                : "Not Repaired Yet"
                            }`}
                          </Typography>
                        </Col>
                        <Col sm={6}>
                          <Typography variant="body1">
                            {dd.partsUsedInRepair !== null
                              ? dd.partsUsedInRepair
                              : ""}
                          </Typography>
                        </Col>
                      </Row>
                    ))
                  ) : (
                    <Row></Row>
                  )}
                </Col>
              </Row>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "stretch"
              }}
            >
              <Row style={{ marginTop: "8px" }}>
                <Typography>
                  <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                    BIT 90-day Mechanical Inspection/ Federal Annual Inspection
                  </span>
                  <span style={{ fontSize: "12px", marginLeft: "2px" }}>
                    (Sticker/Decal Label Required for Annual Inspection Only)
                  </span>
                </Typography>
                <RenderListItemObs items={InspectionCheckData} />
              </Row>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "stretch",
                flexDirection: "column",
                padding: "8px"
              }}
            >
              <Row
                style={{
                  padding: "10px 0px"
                }}
              >
                <Typography style={{ fontSize: "16px", fontWeight: "bold" }}>
                  {" "}
                  Repairs Still Needed{" "}
                </Typography>
              </Row>{" "}
              <hr style={{ padding: 0, margin: 0, size: "5px" }}></hr>
              <Row>
                {defectsActive.length > 0 ? (
                  defectsActive.map((dd, i) => (
                    <Col
                      style={{
                        padding: "8px"
                      }}
                      sm={4}
                      key={dd.id}
                    >
                      <Typography variant="body2">
                        {" "}
                        {`(${i + 1}) Type: ${dd.defectType}`}
                      </Typography>
                      <Typography variant="body1">
                        {" "}
                        {`Description: ${dd.defectDesc}`}
                      </Typography>
                    </Col>
                  ))
                ) : (
                  <Row></Row>
                )}
              </Row>
            </div>

            <div
              style={{
                padding: "8px"
              }}
            >
              <Row>
                <Col
                  style={{
                    border: "2px solid black"
                  }}
                  sm={7}
                >
                  <Row>
                    <div
                      style={{
                        width: "95%",
                        margin: "auto"
                      }}
                    >
                      <div style={{ fontSize: "x-small", textAlign: "center" }}>
                        {" "}
                        <Typography>
                          Computer-generated document does not require
                          signatures.{" "}
                        </Typography>
                      </div>
                      <hr style={{ margin: 0, padding: 0 }}></hr>
                      <div style={{ fontSize: "smaller", textAlign: "center" }}>
                        Mechanic's Signature (Signature Certifies Qualification
                        under FMCSR 396.19)
                      </div>
                    </div>
                  </Row>
                </Col>
                <Col sm={1} />
                <Col
                  style={{
                    border: "2px solid black"
                  }}
                  sm={4}
                >
                  {/* <Row>---------------</Row> */}
                  <div style={{ width: "99%", margin: "auto" }}>
                    <Typography style={{ fontSize: "14px" }}>
                      Next Inspection Due Date:{" "}
                      <span style={{ fontSize: "12px" }}>
                        {inspectionDetails.nextdue}
                      </span>
                    </Typography>
                  </div>
                </Col>
              </Row>
            </div>

            <div
              style={{
                paddingTop: "20px",
                paddingInline: "8px"
              }}
            >
              <Row>
                <Col sm={3}>
                  <Typography variant="caption">
                    Copyright 2020 Calbit.live
                  </Typography>
                </Col>
                <Col sm={6}>
                  <Typography variant="caption">
                    White-Terminal Dispatch Copy Yellow-Admin Copy
                  </Typography>
                </Col>
                <Col sm={3}>
                  <Typography variant="caption">
                    Re Order At: www.calbit.live
                  </Typography>
                </Col>
              </Row>
            </div>
          </div>
        </Paper>
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = state => {
  return {
    client: state.config.client
  };
};
InspectionReportView.propTypes = {
  classes: PropTypes.object.isRequired
};
export default connect(
  mapStateToProps,
  null
)(withStyles(styles)(InspectionReportView));



// WEBPACK FOOTER //
// ./src/views/Company/InspectionReportView.js